import React, { useState, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { Button } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import { customStyles } from "../../utils/data/essential";
import CreateUser from "../../Component/users/CreateUser";
import DisplayUser from "../../Component/users/DisplayUser";
import UpdateUser from "../../Component/users/UpdateUser";
import { userColumns } from "../../utils/columns/userColumns";
import { useFetchData } from "../../hooks/useFetchData";
import useAxios from "../../hooks/useAxios";

const Users = () => {
  const [show, setShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [singleUser, setSingleUser] = useState([]);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showSingleUserModal, setShowSingleUserModal] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  console.log("user on users page:", user);
  const queryClient = useQueryClient();
  const axiosInstance = useAxios();
  const handleShowModal = (type) => {
    if (type === "create") {
      setShowCreateUserModal(true);
    } else if (type === "display") {
      setShowSingleUserModal(true);
    } else {
      setShow(true);
    }
  };
  const handleCloseModal = (type) => {
    if (type === "create") {
      setShowCreateUserModal(false);
    } else if (type === "display") {
      setShowSingleUserModal(false);
    } else {
      setShow(false);
    }
  };
  // Handle sorting handler
  const handleSort = (column, sortDirection) => {
    setSortField(column.selector);
    setSortOrder(sortDirection);
  };
  // Fetch users
  const url = `users?pageNumber=${
    currentPage - 1
  }&sizeNumber=${pageSize}&sortBy=${sortField}`;
  const { data, isLoading } = useFetchData(
    ["fetch-users", currentPage, pageSize, sortField],
    url,
    true
  );
  // Fetch locations
  const filterData = (searchTerm) => {
    if (!searchTerm) {
      return data;
    }
    return data?.filter((dt) => {
      const userMatches =
        dt?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.username?.toLowerCase().includes(searchTerm.toLowerCase());

      // Check locations
      const locationMatches =
        dt?.locations
          ?.flat()
          .some((location) =>
            location?.name?.toLowerCase().includes(searchTerm)
          ) || false;

      return userMatches || locationMatches;
    });
  };
  const filteredData = useMemo(() => filterData(keyword), [data, keyword]);

  const deleteUser = () => {
    const url = `/users/${deleteId}`;

    axiosInstance
      .delete(url)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          toastSuccess("User deleted successfully");
          queryClient.invalidateQueries(["fetch-users"]);
          setShowAlert(false);
        } else {
          toastError("Could not delete user");
        }
      })
      .catch((err) => {
        toastError(err.response?.data?.message || "Could not delete user");
        console.log(err);
      });
  };
  const columns = userColumns(
    user,
    setSingleUser,
    handleShowModal,
    setShow,
    setShowAlert,
    setDeleteId
  );
  if (isLoading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  return (
    <div>
      <>
        <div className='d-flex justify-content-end mr-3'>
          <Button
            className='custom-btn-color'
            onClick={() => handleShowModal("create")}
          >
            <i className='fa fa-plus' />
            &nbsp; Create User
          </Button>
        </div>
        {data?.length > 0 && (
          <form className='flex-container mt-3'>
            {/* <div className='quick-search-container mr-2'>
              <select
                className='form-control input-select'
                onChange={(e) => {
                  if (e.target.value === "Filter by") {
                    setSelectedFilter(null);
                  } else {
                    setSelectedFilter(e.target.value);
                  }
                }}
              >
                <option>Filter by</option>
                <option value={1}>Names</option>
                <option value={2}>Phone number</option>
                <option value={3}>Location</option>
              </select>
            </div>
            {selectedFilter !== null && (
              <div className='quick-search-container'>
                <input
                  type={selectedFilter == 2 ? "number" : "text"}
                  placeholder={
                    selectedFilter == 1
                      ? "Search by user names"
                      : selectedFilter == 2
                      ? "Search by Phone number"
                      : "Search by location name"
                  }
                  className='form-control input-select'
                  required
                />
              </div>
            )}
            {selectedFilter !== null && (
              <div
                className='quick-search-container'
                style={{ marginTop: -20 }}
              >
                <Button className='custom-btn-color ml-2' onClick={refetch}>
                  Search
                </Button>
              </div>
            )} */}
            <div className='quick-search-container'>
              <input
                type='text'
                className='form-control quick-search ml-2'
                placeholder='Quick search by name,phone or location'
                onChange={(e) => setKeyword(e.target.value)}
                style={{ bottom: 0 }}
              />
            </div>
          </form>
        )}
        <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={pageSize}
            onChangeRowsPerPage={(currentRows, currentPage) => {
              setPageSize(currentRows);
              setCurrentPage(currentPage);
            }}
            onChangePage={(currentPage) => setCurrentPage(currentPage)}
            progressPending={isLoading}
            onSort={handleSort}
            customStyles={customStyles}
          />
        </div>
      </>
      {/* Update user */}
      <UpdateUser
        show={show}
        hide={() => handleCloseModal("update")}
        user={singleUser}
      />
      {/* Display user */}
      <DisplayUser
        show={showSingleUserModal}
        hide={() => handleCloseModal("display")}
        singleUser={singleUser}
      />
      {/* Delete user */}
      <SweetAlert
        title='Are you sure?'
        onConfirm={deleteUser}
        onCancel={() => setShowAlert(false)}
        show={showAlert}
        showConfirm={true}
        showCancel={true}
        type='warning'
        cancelBtnBsStyle='primary'
        confirmBtnBsStyle='success'
        cancelBtnText='No'
        confirmBtnText='Yes'
      />
      {/* Create user */}
      <CreateUser
        show={showCreateUserModal}
        hide={() => handleCloseModal("create")}
      />
    </div>
  );
};
export default Users;
